import { saveCookie } from 'core/utils';

class FacebookUtil {
	static login = () => {
		FacebookUtil.authorize();
	}

	static postConnectionLogin = response => {
		const token = response.authResponse.accessToken;
		const nextLoc = window.cj.back_url ? window.cj.back_url : window.location.pathname;
		const uid = response.authResponse.userID;
		let queryString = window.location.search ? window.location.search : '';

		saveCookie();

		window.location = `/sso/facebook?token=${token}&uid=${uid}&next=${nextLoc}${encodeURIComponent(queryString)}`;
	}

	static getLoginStatus = o => {
		const getStatusFn = () => {
			window.FB.getLoginStatus(function(response) {
				if (response.status === 'connected') {
					// FacebookUtil.postConnectionLogin(response);
					o.fbAuthResponse = response;
				}
			});
		};

		if (window.FB) {
			getStatusFn();

		} else {
			const intervalId = setInterval(function() {
				if (window.FB) {
					clearInterval(intervalId);
					getStatusFn();
				}
			}, 300);
		}
	}

	static authorize = () => {
		const authFn = () => {
			window.FB.login(
				function (response) {
					if (response.status === 'connected') {
						FacebookUtil.postConnectionLogin(response);
					} else {
						alert('facebook connection failed');
					}
				}, { scope: 'public_profile,email' }
			);
		};

		if (window.FB) {
			authFn();
		} else {
			var intervalId = setInterval(function() {
				if (window.FB) {
					clearInterval(intervalId);
					authFn();
				}
			}, 300);
		}
	}
}

export default FacebookUtil;
